import { AbpSessionService } from 'abp-ng2-module';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { accountModuleAnimation, UrlHelper } from '@axilla/axilla-shared';
import { AppComponentBase } from '@shared/common/app-component-base';
import { SessionServiceProxy, UpdateUserSignInTokenOutput } from '@shared/service-proxies/service-proxies';
import { ReCaptcha2Component } from 'ngx-captcha';
import { AppConsts } from '@shared/AppConsts';
import { LoginService, ExternalLoginProvider } from "@account/login/login.service";
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'loginModal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.less']
})
export class LoginModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('recaptchaRef') recaptchaRef: ReCaptcha2Component;
    @ViewChild('loginModal', { static: true }) modal: ModalDirective;

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    submitting = false;
    isMultiTenancyEnabled: boolean = this.multiTenancy.isEnabled;
    recaptchaSiteKey: string = AppConsts.recaptchaSiteKey;
    captchaResponse?: string;

    countries: any[] | undefined = [
        { name: 'United Arab Emirates', code: 'AE', flagUrl: 'https://flagcdn.com/ae.svg' },
        { name: 'European Union', code: 'DE', flagUrl: 'https://flagcdn.com/eu.svg' }
    ];
    selectedCountry: string | undefined;

    constructor(
        injector: Injector,
        public loginService: LoginService,
        private _router: Router,
        private _sessionService: AbpSessionService,
        private _sessionAppService: SessionServiceProxy
    ) {
        super(injector);
    }

    show(): void {
        if (this._sessionService.userId > 0 && UrlHelper.getReturnUrl() && UrlHelper.getSingleSignIn()) {
            this._sessionAppService.updateUserSignInToken()
                .subscribe((result: UpdateUserSignInTokenOutput) => {
                    const initialReturnUrl = UrlHelper.getReturnUrl();
                    const returnUrl = initialReturnUrl + (initialReturnUrl.indexOf('?') >= 0 ? '&' : '?') +
                        'accessToken=' + result.signInToken +
                        '&userId=' + result.encodedUserId +
                        '&tenantId=' + result.encodedTenantId;

                    location.href = returnUrl;
                });
        }

        let state = UrlHelper.getQueryParametersUsingHash().state;
        if (state && state.indexOf('openIdConnect') >= 0) {
            this.loginService.openIdConnectLoginCallback({});
        }
        this.modal.show();
    }

    close(): void {
        this.modal.hide();
    }

    goToHome(): void {
        (window as any).location.href = '/';
    }
    get multiTenancySideIsTeanant(): boolean {
        return this._sessionService.tenantId > 0;
    }

    get isTenantSelfRegistrationAllowed(): boolean {
        return this.setting.getBoolean('App.TenantManagement.AllowSelfRegistration');
    }

    get isSelfRegistrationAllowed(): boolean {
        if (!this._sessionService.tenantId) {
            return false;
        }

        return this.setting.getBoolean('App.UserManagement.AllowSelfRegistration');
    }

    get isTenantRegistrationAllowed(): boolean {
        return this.setting.getBoolean('App.UserManagement.AllowTenantRegistration');
    }

    ngOnInit(): void {
        //if (this._sessionService.userId > 0 && UrlHelper.getReturnUrl() && UrlHelper.getSingleSignIn()) {
        //    this._sessionAppService.updateUserSignInToken()
        //        .subscribe((result: UpdateUserSignInTokenOutput) => {
        //            const initialReturnUrl = UrlHelper.getReturnUrl();
        //            const returnUrl = initialReturnUrl + (initialReturnUrl.indexOf('?') >= 0 ? '&' : '?') +
        //                'accessToken=' + result.signInToken +
        //                '&userId=' + result.encodedUserId +
        //                '&tenantId=' + result.encodedTenantId;

        //            location.href = returnUrl;
        //        });
        //}

        //let state = UrlHelper.getQueryParametersUsingHash().state;
        //if (state && state.indexOf('openIdConnect') >= 0) {
        //    this.loginService.openIdConnectLoginCallback({});
        //}
    }

    login(): void {
        if (this.useCaptcha && !this.captchaResponse) {
            this.message.warn(this.l('CaptchaCanNotBeEmpty'));
            return;
        }

        this.spinnerService.show();

        this.submitting = true;
        this.loginService.authenticate(
            () => {
                this.submitting = false;
                this.spinnerService.hide();

                if (this.recaptchaRef) {
                    this.recaptchaRef.resetCaptcha();
                }
            },
            null,
            this.captchaResponse
        );
    }

    externalLogin(provider: ExternalLoginProvider) {
        this.loginService.externalAuthenticate(provider);
    }

    get useCaptcha(): boolean {
        return this.setting.getBoolean('App.UserManagement.UseCaptchaOnLogin');
    }

    captchaResolved(captchaResponse: string): void {
        this.captchaResponse = captchaResponse;
    }

    get isFreeEdition() {
        return abp.features.isEnabled('App.Ubl.CreateNewInvoiceFromHome');
    }
}
